import { render } from "./SelectLanguage.html?vue&type=template&id=8f363f38&scoped=true"
import script from "./SelectLanguage.vue?vue&type=script&lang=ts"
export * from "./SelectLanguage.vue?vue&type=script&lang=ts"

import "./SelectLanguage.scss?vue&type=style&index=0&id=8f363f38&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8f363f38"

export default script